// Action Types
export const UPDATE_SHOP = "UPDATE_SHOP";
export const UPDATE_SHOP_BALANCE = "UPDATE_SHOP_BALANCE";
export const UPDATE_SHOP_STATUS = "UPDATE_SHOP_STATUS";

// Action Creator
export const updateShopInRedux = (newShop, newItems, isFakeShop) => ({
    type: UPDATE_SHOP,
    newShop,
    newItems,
    isFakeShop,
    // Stamped here rather than in the reducer, which has to stay pure.
    updatedAt: Date.now()
});

export const updateShopBalance = (balance, abbreviation) => ({
    type: UPDATE_SHOP_BALANCE,
    balance,
    abbreviation
});

// Whether the player's shop is real or the preview, without its items — for the
// parts of the site that need to know but never render the shop.
export const updateShopStatus = (isFakeShop) => ({
    type: UPDATE_SHOP_STATUS,
    isFakeShop
});
